import '@space/utils'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
import VConsole from 'vconsole'
import * as filters from '@/common/utils'
import App from './app.vue'
import router from './router'
import { requireVant } from '@/common'
import '@/common/svg-require'

import 'babel-polyfill'

const isDev = process.env.NODE_ENV !== 'production'
// if (isDev) {
// new VConsole({ maxLogNumber: 1000 })
// }

requireVant(Vue)
Es6Promise.polyfill()
Vue.config.productionTip = false
Vue.config.devtools = isDev
Object.keys(filters).map((key: any) => {
  Vue.filter(key, (filters as any)[key])
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})
